import { render } from "./AddEditFranchiseGroup.vue?vue&type=template&id=93fcacac"
import script from "./AddEditFranchiseGroup.vue?vue&type=script&lang=js"
export * from "./AddEditFranchiseGroup.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__